export enum VisitorTypes {
  newVisitor = 0,
  returningVisitor = 1,
  conversionVisitor = 2,
}

export type VisitorsMapSelectedPoint = {
  location: {
    longitude: number;
    latitude: number;
  };
  sessionId: string;
};
